<script setup>
import { onMounted } from 'vue'

onMounted(() => {
  // Trigger an error for Sentry testing
  const undefinedObject = undefined
  undefinedObject.callMethod()
})
</script>

<template>
  <div class="pa-4">
    <h1>Sentry Error Test</h1>
    <p>This page should trigger an error...</p>
  </div>
</template>

<route lang="yaml">
meta:
  layout: website
  action: read
  subject: Auth
</route>
